import axios from "./axiosWrapper";

function unwrapFalconPayload(res) {
    const body = res?.data;
    if (body && typeof body === "object" && "data" in body) {
        return body.data;
    }
    return body;
}

function withUnwrappedData(promise) {
    return promise.then((res) => ({
        ...res,
        data: unwrapFalconPayload(res),
    }));
}

const Utility = {
    getCountries() {
        return withUnwrappedData(axios.get('/utility/get-countries'));
    },
    getStates(code) {
        return withUnwrappedData(axios.get(`/utility/get-states/${code}`));
    },
    updateCountryVisibility(showCountry, countryID) {
        return withUnwrappedData(axios.put(`/utility/update-country-visibility/${countryID}`,
            {
                showCountry: showCountry,
            }));
    },
    getInstitutionTypes() {
        return withUnwrappedData(axios.get('/utility/institution-types'));
    },
    addInstitutionType(data) {
        return withUnwrappedData(axios.post('/utility/institution-type', data));
    },
    updateInstitutionType(data, id) {
        return withUnwrappedData(axios.put(`/utility/institution-type/${id}`, data));
    },
    deleteInstitutionType(id) {
        return withUnwrappedData(axios.delete(`/utility/institution-type/${id}`));
    },
    getDegrees() {
        return withUnwrappedData(axios.get(`/utility/degrees`));
    },
    addDegree(data) {
        return withUnwrappedData(axios.post(`/utility/degree`,
            data));
    },
    updateDegree(data, id) {
        return withUnwrappedData(axios.put(`/utility/degree/${id}`,
            data));
    },
    deleteDegree(id) {
        return withUnwrappedData(axios.delete(`/utility/degree/${id}`));
    },
}

export default Utility;